import { takeLatest } from 'redux-saga/effects'
import { ADD_CHAT_MESSAGE } from '../redux/chatMessagesReducer'
import { PayloadAction } from '@reduxjs/toolkit'
import { Message } from '../types'

type action = PayloadAction<Message>

function* AddChatMessageNotificationFlow({ payload }: action): Generator<any, void, any> {
  if (payload.author === 'student') {
    const audio = new Audio('/message.mp3')
    yield audio.play()
  }
}

export default function* AddChatMessageNotificationSaga(): Generator<any, void, any> {
  yield takeLatest([ADD_CHAT_MESSAGE], AddChatMessageNotificationFlow)
}
